<template>
    <survey-basic :survey_hash="this.survey_hash"></survey-basic>
</template>

<script>
    import SurveyBasic from "../components/surveys/SurveyBasic";
    import {
        FETCH_USER_SURVEY
    } from '../store/actions';

    export default {
        name: "Survey",
        components: {SurveyBasic},
        data: function () {
            return {
                survey_hash: ''
            }
        },
        mounted: function () {
            this.$store.dispatch(FETCH_USER_SURVEY, {'id': this.$route.params.id}).then(
                response => {
                    this.survey_hash = response.data.survey_hash;
                }
            ).catch(error => {
                console.log(error);
            });
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Survey.vue